import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/Animation/Shishito-Mark-1.json';
import { useMediaQuery } from 'react-responsive';

const ShishitoAnimation = ({ onComplete }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  
  return (
    <div className="flex items-center justify-center h-[60vh] min-h-[500px]">
      <Lottie
        animationData={animationData}
        loop={false}
        autoplay={true}
        style={{ 
          height: isMobile ? 150 : 225, 
          width: isMobile ? 150 : 225 
        }}
        onComplete={onComplete}
      />
    </div>
  );
};

export default ShishitoAnimation;